import { render, staticRenderFns } from "./BackProfile.vue?vue&type=template&id=7b347d63&scoped=true&"
var script = {}
import style0 from "./BackProfile.vue?vue&type=style&index=0&id=7b347d63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b347d63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7b347d63', component.options)
    } else {
      api.reload('7b347d63', component.options)
    }
    module.hot.accept("./BackProfile.vue?vue&type=template&id=7b347d63&scoped=true&", function () {
      api.rerender('7b347d63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/BackProfile.vue"
export default component.exports